document.addEventListener("DOMContentLoaded", function () {
  const authorBox = document.querySelector(".author-box");
  const faqSection = document.querySelector(".faq-section");

  if (authorBox && faqSection) {
    faqSection.insertAdjacentElement("afterend", authorBox);
  }
});

document.addEventListener("DOMContentLoaded", function () {

    // Get page title
    let pageTitle = document.title;

    // Convert title into class-friendly format
    let bodyClass = pageTitle
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // Replace spaces & special chars with -
        .replace(/^-+|-+$/g, ''); // Remove extra -

    // Add custom suffix
    bodyClass = bodyClass + '-custom';

    // Add class to body
    document.body.classList.add(bodyClass);

});

document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('load-more');
  if (!button) return;

  button.addEventListener('click', function () {
    const nextUrl = button.dataset.nextUrl;

    if (!nextUrl) return;

    button.disabled = true;
    button.textContent = 'Loading...';

    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newArticles = doc.querySelectorAll('#blog-grid .blog-articles__article');
        const grid = document.querySelector('#blog-grid');

        newArticles.forEach(article => {
          grid.appendChild(article);
        });

        const nextButton = doc.querySelector('#load-more');

        if (nextButton) {
          button.dataset.nextUrl = nextButton.dataset.nextUrl;
          button.disabled = false;
          button.textContent = 'Load More';
        } else {
          button.remove();
        }
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = 'Load More';
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {

    const loadMoreBtn = document.getElementById("load-more");

    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener("click", function () {

        const nextUrl = this.dataset.nextUrl;

        if (!nextUrl) return;

        loadMoreBtn.disabled = true;
        loadMoreBtn.innerHTML = "Loading...";

        fetch(nextUrl)
            .then(response => response.text())
            .then(html => {

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                const newProducts = doc.querySelector("#product-grid");
                const productGrid = document.querySelector("#product-grid");

                productGrid.insertAdjacentHTML(
                    "beforeend",
                    newProducts.innerHTML
                );

                const newButton = doc.querySelector("#load-more");

                if (newButton) {
                    loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl;
                    loadMoreBtn.disabled = false;
                    loadMoreBtn.innerHTML = "Load More";
                } else {
                    loadMoreBtn.remove();
                }

            });

    });

});

$('.collection-slides').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: `
    <button type="button" class="slick-next">
      <svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.365448 0.348877L13.3591 13.6891L0.365448 27.6068" stroke="black"/>
      </svg>
    </button>
  `,

  prevArrow: `
    <button type="button" class="slick-prev">
      <svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.6845 0.348877L0.690861 13.6891L13.6845 27.6068" stroke="black"/>
      </svg>
    </button>
  `,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(document).ready(function () {
  if ($(window).width() >= 992) {

    $('.product__media-list').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.thumbnail-list',

      nextArrow: `
        <button type="button" class="slick-next">
          <svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.365448 0.348877L13.3591 13.6891L0.365448 27.6068" stroke="black"/>
          </svg>
        </button>
      `,

      prevArrow: `
        <button type="button" class="slick-prev">
          <svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6845 0.348877L0.690861 13.6891L13.6845 27.6068" stroke="black"/>
          </svg>
        </button>
      `
    });

    $('.thumbnail-list').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product__media-list',
      focusOnSelect: true,
      vertical: false,
      infinite: false,
      arrows: false,
      dots: false
    });

  }

  $(document).on('click', '.menu-drawer__close-btn', function() {
    $('body').removeClass('overflow-hidden-tablet');
});


    if ($(window).width() > 767) return;

    const sliderInterval = setInterval(function () {

        const $slider = $('.related-products ul');

        // Check section exists, has items, and slick is not initialized
        if (
            $slider.length &&
            $slider.find('li').length > 1 &&
            !$slider.hasClass('slick-initialized')
        ) {

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: false
            });

            clearInterval(sliderInterval); // Stop checking once initialized
        }

    }, 500);

});
document.querySelectorAll('.article-body p').forEach(function(p) {
  if (p.innerHTML.trim() === '&nbsp;' || p.textContent.trim() === '') {
    p.remove();
  }
});